import {
  Sheet,
  SheetContent,
  SheetBody,
  SheetHeader,
  SheetTitle,
} from "@repo/ui/components/Base/Sheet";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { DocumentForm } from "./DocumentForm";
import { useGetDocument } from "@/hooks/queryHooks/documentHooks";

interface EditDocumentSheetProps {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  tenantId: string;
  documentId: string;
}
export const EditDocumentSheet = ({
  open,
  setOpen,
  tenantId,
  documentId,
}: EditDocumentSheetProps) => {
  const { data: document } = useGetDocument(tenantId, documentId);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="overflow-y-scroll">
        <SheetHeader>
          {!document && <Spinner />}
          {document && (
            <div>
              <SheetTitle>{`Edit ${document.name}`}</SheetTitle>
              <SheetBody>
                <DocumentForm
                  documentFormData={document}
                  tenantId={tenantId}
                  handleCancel={() => setOpen(false)}
                  handleComplete={() => setOpen(false)}
                />
              </SheetBody>
            </div>
          )}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
